import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { AlertStore, IAlertStore } from '../alert-store/AlertStore';
import { AuthStore, IAuthStore } from '../auth-store/AuthStore';
import {
  ConversationStore,
  IConversationStore,
} from '../chatbot/conversation-store/ConversationStore';
import { CommonCdStore, ICommonCdStore } from '../common-cd-store/CommonCdStore';
import { withEnvironment } from '../extensions/withEnvironment';
import { ILoadingStore, LoadingStore } from '../loading-store/LoadingStore';
import { ISnackbarStore, SnackbarStore } from '../snackbar-store/SnackbarStore';
import { ITimerStore, TimerStore } from '../timer-store/TimerStore';

export const RootStoreModel = types
  .model('RootStore')
  .props({
    loadingStore: types.optional(LoadingStore, {} as ILoadingStore),
    snackbarStore: types.optional(SnackbarStore, {} as ISnackbarStore),
    authStore: types.optional(AuthStore, {} as IAuthStore),
    commonCdStore: types.optional(CommonCdStore, {} as ICommonCdStore),
    conversationStore: types.optional(ConversationStore, {} as IConversationStore),
    timerStore: types.optional(TimerStore, {} as ITimerStore),
    alertStore: types.optional(AlertStore, {} as IAlertStore),
  })
  .extend(withEnvironment);

/**
 * The RootStore instance.
 */
export interface RootStore extends Instance<typeof RootStoreModel> {}

/**
 * The data of a RootStore.
 */
export interface RootStoreSnapshot extends SnapshotOut<typeof RootStoreModel> {}
